import React from 'react';
import ContactInfo from '../molecules/ContactInfo';
import { Box, Container, Stack, Typography } from '@mui/material';
import { useTrackPageEffect } from 'hooks/services/useTrackPageEffect';
import { AuditEvent } from 'types/track/AuditEventType';

export const ContactUs = () => {
   useTrackPageEffect({
        eventType: AuditEvent.MemberPortalViewContactUs,
    });
    return (
        <Container component="main" id="contact-us-page">
            <Stack spacing={2}>
                <Typography variant="h3" gutterBottom textAlign="center" fontWeight="bold">
                    Call Us
                </Typography>
                <Box pb={4}>
                    <ContactInfo />
                </Box>
            </Stack>
        </Container>
    );
};

export default ContactUs;
